import React, { useEffect } from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import {Link, useNavigate} from 'react-router-dom';
import NavLogin from '../components/NavLogin';


function Navbar ({search,setSearch}) {
  const [user,setUser] = useState("");
  const [nav , setNav] = useState(false);
  const [cartShop , setCartShop] = useState(false);
  const [display,setDisplay]=useState(false);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const carts = useSelector(state => state.cartReducer.carts)

    const openLog = ()=>{
      setNav(true)
    }

    const showCart =()=>{
      setCartShop (true)
  }

  const showProfil =()=>{
    setDisplay(true)
  }
  const closeProfil =()=>{
    setDisplay(false)
  }
  const showMenu = () =>{
    setDisplay(true)
}
const affi = ()=> {
  setDisplay (false)
}

  const logout =()=>{
    localStorage.clear();
    navigate('/');
  }
  const auth = localStorage.getItem("user");

  const handleSearch = (e)=>{
    setSearch(e.target.value)
  }
  const searching =(e)=>{
    navigate('/searching');
    setSearch(e.target.value)
  }

    return (
      <div>
      <header>

        { auth ? (
        <div className='navbar'>
           <div className="navbar--left">
          <div className='icon--menu' onClick={showMenu}>
               <i className="fa-solid fa-bars"></i>
               </div>
            <div className="navbar--logo">
            <Link to="/" className='header__title'><h5>SHOPPING<span>BAG</span></h5></Link>
              {/* <Link to="/"> <img src={`${process.env.PUBLIC_URL}/easy.png`} alt=""/></Link> */}
              {/* <img src="" alt="" /> */}
            </div>
          </div>
          <div className="navbar--center">
            <div className="navbar--center--content">
              <div className="col-3 col-md-8">
                <form class="d-flex" role="search">
                <input class="form-control me-3" type="search" placeholder="Cherchez un produit , une marque ou une categorie..." aria-label="Search" onChange={handleSearch}/>
                <button class="btn btn-outline-success" onClick={searching}>Search</button>
                {/* <Link className='liste' to="/">Accueil</Link> */}
              </form>
              </div>
            </div>
            <div className='logo--resp'>
              <div className="navbar--logo--resp">
                {/* <Link to="/"> <img src={`${process.env.PUBLIC_URL}/easy.png`} alt=""/></Link> */}
                <Link to="/" className='header__title'><h5>SHOPPING<span>BAG</span></h5></Link>
              </div>
            </div>
          </div>

        
          <div className="navbar--right">
          <div className="navbar--right--content">
                       <NavLogin nav={nav} setNav={setNav}/>
                       <Link className='liste' ><button onClick={openLog} className="btn--connexion"><i className="fa-solid fa-user"></i> Mon profil </button></Link>
                  </div>
          </div>
         </div>
        ) : (
          <div className='navbar'>
          <div className="navbar--left">
          <div className='icon--menu' onClick={showMenu}>
               <i className="fa-solid fa-bars"></i>
               </div>
            <div className="navbar--logo">
            <Link to="/" className='header__title'><h5>SHOPPING<span>BAG</span></h5></Link>
              {/* <Link to="/"> <img src={`${process.env.PUBLIC_URL}/easy.png`} alt=""/></Link> */}
              {/* <img src="" alt="" /> */}
            </div>
          </div>
          <div className="navbar--center">
            <div className="navbar--center--content">
              <div className="col-3 col-md-8">
                <form class="d-flex" role="search">
                <input class="form-control me-3" type="search" placeholder="Cherchez un produit , une marque ou une categorie..." aria-label="Search" onChange={handleSearch}/>
                <button class="btn btn-outline-success" onClick={searching}>Search</button>
                {/* <Link className='liste' to="/">Accueil</Link> */}
              </form>
              </div>
            </div>
            <div className='logo--resp'>
              <div className="navbar--logo--resp">
                {/* <Link to="/"> <img src={`${process.env.PUBLIC_URL}/easy.png`} alt=""/></Link> */}
                <Link to="/" className='header__title'><h5>SHOPPING<span>BAG</span></h5></Link>
              </div>
            </div>
          </div>
          <div className="navbar--right">
          <div className="navbar--right--content">
                       <Link to='/loginPage'><button className="btn--connexion"> <i class="fa-solid fa-user"></i>  Connexion</button></Link>
                  </div>
          </div>
         </div>
        )}

        <div className={display ? "menu show--menu" : "menu"}>
                    <div className='sidebar--menu'>
                        <div className='btn--close--sidebar' onClick={affi}>
                            <i className="fa-solid fa-xmark"></i>
                        </div>
                        <div className='menu__content'>
                          <div className='menu__content__liste'>
                            <Link className='list' to="/"><i class="fa-solid fa-bars"></i> Accueil</Link>
                          </div>
                          <div className='menu__content__liste'>
                          <Link className='list' to='/men'><i class="fa-solid fa-person-dress"></i> Hommes</Link>
                          </div>
                          <div className='menu__content__liste'>
                          <Link className='list' to='/women'><i class="fa-solid fa-person-dress"></i> Femmes</Link>
                          </div>
                            <div className='menu__content__liste'>
                            <Link className='list' to='/child'><i class="fa-solid fa-baby"></i> Bébés</Link>
                            </div>
                            <div className='menu__content__liste'>
                              <Link className='list' to='/beauty'> <i class="fa-solid fa-wand-magic-sparkles"></i> Beauté & Hygiène</Link>
                            </div>
                            <div className='menu__content__liste'>
                            <Link className='list' to='/informatiques'> <i class="fa-solid fa-laptop"></i> Informatiques</Link>
                            </div>
                            <div className='menu__content__liste'>
                            <Link className='list' to='/smartphones'><i class="fa-solid fa-mobile"></i> Smartphones & Tablettes</Link>
                            </div>
                            <div className='menu__content__liste'>
                            <Link className='list' to='/house'><i class="fa-solid fa-house"></i> Maisons & Bureau</Link>
                            </div>
                            <div className='menu__content__liste'>
                            <Link className='list' to='/supermarket'><i class="fa-solid fa-shop"></i> Supermarché</Link>
                            </div>
                            <div className='menu__content__liste'>
                            <Link className='list' to='/contact'><i class="fa-solid fa-phone"></i> Contact</Link>
                            </div>
                          <div className="col-12 col-md-12">
                            <form class="d-flex" role="search">
                            <input class="form-control me-2" type="search" placeholder="Cherchez un produit , une marque ou une categorie..." aria-label="Search"/>
                            <button class="btn btn-outline-success" type="submit">Search</button>
                          </form>
                          </div>
                        </div>
                        </div>

        </div>

    </header>
              
      <div className='header__bar'>
        <div className='header__bar__content'>
              <Link className='liste' to="/"><i class="fa-solid fa-bars"></i> Accueil</Link>
              <Link className='liste' to='/men'><i class="fa-solid fa-person-dress"></i> Hommes</Link>
              <Link className='liste' to='/women'><i class="fa-solid fa-person-dress"></i> Femmes</Link>
              <Link className='liste' to='/child'><i class="fa-solid fa-baby"></i> Bébés</Link>
              <Link className='liste' to='/beauty'> <i class="fa-solid fa-wand-magic-sparkles"></i> Beauté & Hygiène</Link>
              <Link className='liste' to='/informatiques'> <i class="fa-solid fa-laptop"></i> Informatiques</Link>
              <Link className='liste' to='/smartphones'><i class="fa-solid fa-mobile"></i> Smartphones & Tablettes</Link>
              {/* <Link className='liste' to='/accessoires'><i class="fa-solid fa-bookmark"></i> Accessoires</Link> */}
              <Link className='liste' to='/house'><i class="fa-solid fa-house"></i> Maisons & Bureau</Link>
              <Link className='liste' to='/supermarket'><i class="fa-solid fa-shop"></i> Supermarché</Link>
              {/* <Link className='liste' to='/shoes'>Shoes</Link> */}
              <Link className='liste' to='/contact'><i class="fa-solid fa-phone"></i> Contact</Link>
        </div>
      </div>

              </div>
    );
}

export default Navbar;
